"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionMode = void 0;
var PayazaCheckoutDataDefaults_1 = require("./PayazaCheckoutDataDefaults");
var PayazaCallbackData_1 = require("./PayazaCallbackData");
var Validator_1 = __importStar(require("./Validator"));
var ConnectionMode;
(function (ConnectionMode) {
    ConnectionMode["LIVE"] = "Live";
    ConnectionMode["TEST"] = "Test";
})(ConnectionMode = exports.ConnectionMode || (exports.ConnectionMode = {}));
var PayazaCheckout = /** @class */ (function () {
    function PayazaCheckout(data) {
        var _this = this;
        // readonly CHECKOUT_ORIGIN = `http://localhost:3000`;
        this.CHECKOUT_ORIGIN = "https://checkout.payaza.africa";
        this.fieldRules = [
            {
                field: "merchant_key",
                rules: [Validator_1.ValidationRule.REQUIRED, Validator_1.ValidationRule.NOT_BLANK],
            },
            {
                field: "checkout_amount",
                rules: [
                    Validator_1.ValidationRule.REQUIRED,
                    Validator_1.ValidationRule.NOT_NULL,
                    Validator_1.ValidationRule.NUMERIC,
                ],
            },
            {
                field: "currency_code",
                rules: [Validator_1.ValidationRule.NULLABLE, Validator_1.ValidationRule.NOT_NULL],
            },
            {
                field: "first_name",
                rules: [Validator_1.ValidationRule.REQUIRED, Validator_1.ValidationRule.NOT_BLANK],
            },
            {
                field: "last_name",
                rules: [Validator_1.ValidationRule.REQUIRED, Validator_1.ValidationRule.NOT_BLANK],
            },
            {
                field: "email_address",
                rules: [
                    Validator_1.ValidationRule.REQUIRED,
                    Validator_1.ValidationRule.NOT_BLANK,
                    Validator_1.ValidationRule.EMAIL,
                ],
            },
            {
                field: "phone_number",
                rules: [Validator_1.ValidationRule.NOT_NULL],
            },
            {
                field: "transaction_reference",
                rules: [Validator_1.ValidationRule.NOT_BLANK, Validator_1.ValidationRule.REQUIRED],
            },
        ];
        this.callback = function (response) { };
        this.onClose = function () { };
        this.handleResizeEvent = function () {
            _this.setIframeSize();
        }; //end handleResizeEvent
        this.handleMessageEvent = function (event) {
            if (event.origin !== _this.CHECKOUT_ORIGIN)
                return;
            switch (event.data.type) {
                case PayazaCallbackData_1.PayazaCallbackResponseType.ACTION:
                    _this.handleIframeActions(event.data);
                    break;
                case PayazaCallbackData_1.PayazaCallbackResponseType.ERROR_CLIENT:
                    _this.handleClientError(event.data);
                    break;
                case PayazaCallbackData_1.PayazaCallbackResponseType.SUCCESS:
                    _this.handleSuccess(event.data);
            }
        }; //end method handleMessageEvent
        var options = __assign({}, PayazaCheckoutDataDefaults_1.defaultData);
        //Populate the default with the options
        Object.assign(options, data);
        if (options.onClose) {
            this.setOnClose(options.onClose);
            delete options.onClose;
        }
        if (options.callback) {
            this.setCallback(options.callback);
            delete options.callback;
        }
        if (!options.connection_mode)
            options.connection_mode = PayazaCheckout.TEST_CONNECTION_MODE;
        this.data = options;
    } //end constructor
    PayazaCheckout.setup = function (data) {
        return new PayazaCheckout(data);
    }; //end setup method
    PayazaCheckout.prototype.setCallback = function (callback) {
        this.callback = callback;
    }; //end method setCallback
    PayazaCheckout.prototype.setOnClose = function (onClose) {
        this.onClose = onClose;
    }; //end method setOnclose
    PayazaCheckout.prototype.showPopup = function () {
        var _this = this;
        // TODO: do validations here
        var validator = new Validator_1.default(this.fieldRules);
        var errors = validator.validate(this.data).getErrors();
        if (errors.length > 0) {
            this.handleClientError({
                type: PayazaCallbackData_1.PayazaCallbackResponseType.ERROR,
                status: PayazaCallbackData_1.PayazaResponseStatus.VALIDATION_ERROR,
                data: { message: "Error during validation", errors: errors },
            });
            return;
        }
        this.addLoader();
        var iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.opacity = "0";
        iframe.style.zIndex = "2147483647";
        iframe.style.border = "none";
        iframe.src = this.CHECKOUT_ORIGIN;
        iframe.allow = "clipboard-read " + this.CHECKOUT_ORIGIN + "; clipboard-write " + this.CHECKOUT_ORIGIN;
        this.iframe = iframe;
        this.setIframeSize();
        this.iframe.onload = function () {
            // For showing the iframe check this.handleIframeActions[loaded-data] ====>>>> this.showHiddenIframe
            // Send the user data to the iframe
            _this.iframe.contentWindow.postMessage({ type: "initial-data", userData: _this.data }, _this.CHECKOUT_ORIGIN);
        };
        document.body.appendChild(this.iframe);
        window.addEventListener("resize", this.handleResizeEvent);
        window.addEventListener("message", this.handleMessageEvent);
    }; //end method showPopup
    PayazaCheckout.prototype.addLoader = function () {
        var createdStyleTag = document.createElement("style");
        createdStyleTag.textContent =
            "@keyframes payaza-loading-spinner{" +
                "to{ transform: rotate(360deg); }" +
                "}";
        var loaderString = "\n      <div\n        style=\"color: white; position: fixed; top: 0; right: 0; left: 0; bottom: 0; background: rgb(7 17 42 / 50%); backdrop-filter: blur(2px); display: flex; align-items: center; justify-content: center;\">\n        <svg height=\"50\" width=\"50\" aria-hidden=\"true\" focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 512 512\" style=\"animation: payaza-loading-spinner infinite 1s linear;\">\n          <path fill=\"currentColor\"\n            d=\"M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z\">\n          </path>\n        </svg>\n      </div>\n      ";
        // const loader = new DOMParser().parseFromString(loaderString, "text/xml");
        var loader = document.createElement("div");
        loader.innerHTML = loaderString;
        this.loader = loader;
        this.createdStyleTag = createdStyleTag;
        document.body.appendChild(createdStyleTag);
        document.body.appendChild(loader);
    }; //end method addLoader
    PayazaCheckout.prototype.removeLoader = function () {
        if (this.createdStyleTag)
            document.body.removeChild(this.createdStyleTag);
        if (this.loader)
            document.body.removeChild(this.loader);
    }; //end method removeLoader
    PayazaCheckout.prototype.removePopup = function () {
        window.removeEventListener("resize", this.handleResizeEvent);
        window.removeEventListener("message", this.handleMessageEvent);
        if (!this.iframe)
            return;
        document.body.removeChild(this.iframe);
        this.iframe = undefined;
    }; //end method removePopup
    PayazaCheckout.prototype.setIframeSize = function () {
        if (!this.iframe) {
            return;
        }
        this.iframe.width = window.innerWidth;
        this.iframe.height = window.innerHeight;
    }; //end method setIframeSize
    PayazaCheckout.prototype.handleIframeActions = function (actionObject) {
        switch (actionObject.data) {
            case "close":
                this.closeIframe();
                break;
            case "loaded-data":
                this.showHiddenIframe();
                break;
        }
    }; //end method handleIframeActions
    PayazaCheckout.prototype.handleClientError = function (data) {
        this.callback({
            type: PayazaCallbackData_1.PayazaCallbackResponseType.ERROR,
            status: data.status || 400,
            data: data.data,
        });
    }; //end method handleClientError
    PayazaCheckout.prototype.handleSuccess = function (data) {
        this.callback({
            type: PayazaCallbackData_1.PayazaCallbackResponseType.SUCCESS,
            status: PayazaCallbackData_1.PayazaResponseStatus.SUCCESS,
            data: data.data,
        });
    };
    PayazaCheckout.prototype.showHiddenIframe = function () {
        // Remove the loader
        try {
            this.removeLoader();
        }
        catch (e) { }
        if (this.iframe) {
            this.iframe.style.opacity = "1";
        }
    }; //end method showHiddenIframe
    PayazaCheckout.prototype.closeIframe = function () {
        this.removePopup();
        this.onClose();
    }; //end method closeIframe
    // readonly CHECKOUT_ORIGIN = `https://checkout-dev.78financials.com`;
    PayazaCheckout.LIVE_CONNECTION_MODE = ConnectionMode.LIVE;
    PayazaCheckout.TEST_CONNECTION_MODE = ConnectionMode.TEST;
    return PayazaCheckout;
}()); //end class PayazaCheckout
exports.default = PayazaCheckout;
